module.exports = __webpack_public_path__ + "static/img/icon-remove.109b2b15.svg";